import { iUserData } from "../services/auth/user.interface";

export const canAccess = (authorization: iUserData["authorization"], policy: tAccessPolicy): boolean => {
    if (typeof policy === "boolean")
        return policy;

    if (typeof policy === "string")
        return authorization[policy];

    if (Array.isArray(policy))
        policy = {
            operation: "or",
            policies: policy
        };

    if (policy.operation == "or")
        return policy.policies.some(policy => canAccess(authorization, policy));

    if (policy.operation == "and")
        return policy.policies.every(policy => canAccess(authorization, policy));

    return false;
};

export const canAccessWithDepartment = (authorization: iUserData["authorization"], department: string, policy: tAccessPolicyWithDepartment): boolean => {
    if (typeof policy === "boolean")
        return policy;

    if (typeof policy === "string")
        return authorization[policy];

    if (Array.isArray(policy))
        policy = {
            operation: "or",
            policies: policy
        };

    if ("department" in policy)
        return department.trim() == policy.department.trim();

    if (policy.operation == "or")
        return policy.policies.some(policy => canAccessWithDepartment(authorization, department, policy));

    if (policy.operation == "and")
        return policy.policies.every(policy => canAccessWithDepartment(authorization, department, policy));

    return false;
};

export type tAccessPolicy = boolean | tAvailableAcessPolicy | tAvailableAcessPolicy[] | {
    operation: 'or' | 'and',
    policies: tAccessPolicy[]
};

type tAvailableAcessPolicy = (keyof iUserData["authorization"]);

export type tAccessPolicyWithDepartment = boolean | tSingeValuePolicy | tSingeValuePolicy[] | {
    operation: 'or' | 'and',
    policies: tAccessPolicyWithDepartment[]
};

type tSingeValuePolicy = tAvailableAcessPolicy | iDepartment;

interface iDepartment {
    department: string;
}